module.exports = __webpack_public_path__ + "static/img/8.ce449ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/eng/8.png
// module id = GuGE
// module chunks = 0